// 随出
const tallyRouter = [
  // 拣货规则
  {
    path: "picking/PickingRule",
    name: "PickingRule",
    component: () => import("../pages/picking/PickingRule.vue"),
    meta: {
      title: "拣货基础配置",
    },
  },
  // 拣货任务列表
  {
    path: "picking/PickingAssignment",
    name: "PickTabs",
    component: () => import("../pages/picking/PickTabs.vue"),
    meta: {
      title: "拣货任务列表",
    },
  },

  // 查看明细
  {
    path: "picking/PickAssignmentDetail/:task_id/:source?",
    name: "PickAssingmentDetail",
    component: () => import("../pages/picking/PickAssingmentDetail.vue"),
    meta: {
      title: "拣货任务明细",
    },
  },

  // 拣货明细日志
  {
    path: "picking/PickAssingmentRecord/:task_no?",
    name: "PickAssingmentRecord",
    component: () => import("../pages/picking/PickAssingmentRecord.vue"),
    meta: {
      title: "拣货日志明细",
    },
  },

  // 无数据处理报表
  {
    path: "nodatagoods/NoDataGoodsReport",
    name: "noDataGoodsReport",
    component: () => import("../pages/nodatagoods/NoDataGoodsReport.vue"),
    meta: {
      title: "无数据处理报表",
    },
  },

  // 无数据处理报表详情
  {
    path: "nodatagoods/NoDataGoodsReportDetail/:date?",
    name: "noDataGoodsReportDetail",
    component: () => import("../pages/nodatagoods/NoDataGoodsReportDetail.vue"),
    meta: {
      title: "无数据处理报表详情",
    },
  },
  // 中分位分组
  {
    path: "surpassSummary/halveGroupList",
    name: "SurpassSummaryHalveGroupList",
    component: () => import("../pages/surpassSummary/halveGroupList.vue"),
    meta: {
      title: "中分位分组",
    },
  },
  // 中分位管理
  {
    path: "surpassSummary/halveGroupDetailList",
    name: "SurpassSummaryHalveGroupDetailList",
    component: () => import("../pages/surpassSummary/halveGroupDetailList.vue"),
    meta: {
      title: "中分位管理",
    },
  },

  // 中分任务监控
  {
    path: "surpassSummary/surpassSummaryMonitor",
    name: "SurpassSummarySurpassSummaryMonitor",
    component: () =>
      import("../pages/surpassSummary/surpassSummaryMonitor.vue"),
    meta: {
      title: "中分任务监控",
    },
  },

  // 中分任务列表
  {
    path: "surpassSummary/surpassSummaryList",
    name: "SurpassSummarySurpassSummaryList",
    component: () => import("../pages/surpassSummary/surpassSummaryList.vue"),
    meta: {
      title: "中分任务列表",
    },
  },

  // 中分任务明细
  {
    path: "surpassSummary/surpassSummaryDetailList/:surpass_summary_id",
    name: "SurpassSummarySurpassSummaryDetailList",
    component: () =>
      import("../pages/surpassSummary/surpassSummaryDetailList.vue"),
    meta: {
      title: "中分任务明细",
    },
  },
  // 中分汇总
  {
    path: "surpassSummary/surpassSummaryPickingList",
    name: "SurpassSummarySurpassSummaryPickingList",
    component: () =>
      import("../pages/surpassSummary/surpassSummaryPickingList.vue"),
    meta: {
      title: "中分汇总",
    },
  },

  // 买版计划列表
  {
    path: "wcgplan/SampleGoodsPlanlist",
    name: "SampleGoodsPlanList",
    component: () => import("../pages/wcgplan/SampleGoodsPlanList.vue"),
    meta: {
      title: "买版计划列表",
    },
  },

  // 买版计划添加
  {
    path: "wcgplan/SampleGoodsPlanEdit/:id",
    name: "SampleGoodsPlanEdit",
    component: () => import("../pages/wcgplan/SampleGoodsPlanEdit.vue"),
    meta: {
      title: "新建/编辑买版计划",
    },
  },

  // 买版计划详情
  {
    path: "wcgplan/SampleGoodsPlanDetail/:id",
    name: "SampleGoodsPlanDetail",
    component: () => import("../pages/wcgplan/SampleGoodsPlanDetail.vue"),
    meta: {
      title: "买版计划详情",
    },
  },

  // 越库vip用户设置
  {
    path: "setting/surpass_vip_user",
    name: "SettingSurpassVipUser",
    component: () => import("../pages/setting/SurpassVipUser.vue"),
    meta: {
      title: "VIP用户列表",
    },
  },

  {
    path: "picking/CrossAssigmentDetail",
    name: "CrossAssigmentDetail",
    component: () => import("../pages/picking/CrossAssigmentDetail.vue"),
    meta: {
      title: "拣货任务明细",
    },
  },
];

export default tallyRouter;



// WEBPACK FOOTER //
// ./src/router/randOut.js